<template>
  <button
    :class="classes"
    :disabled="disabled"
    v-on="$listeners.click ? { click: $listeners.click } : {}"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: 'KfButton',
  props: {
    type: {
      type: String,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      return {
        [`btn-${this.type}`]: this.type,
        'is-disabled': this.disabled,
      };
    },
  },
};
</script>
